<template>
  <v-dialog :value="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-row no-gutters>
        <v-col>
          <iframe v-if="pdf" :src="pdf" frameborder="0" class="espelho-ponto-pdf"></iframe>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EModalEspelhoPontoPdf",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    pdf: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "Espelho de Ponto",
    },
  },
};
</script>

<style scoped>
.espelho-ponto-pdf {
  min-height: calc(100vh - 64px);
  width: 100%;
}
</style>
